import { motion } from "framer-motion";

export const PageHero = ({ overline, title, subtitle, image }) => (
  <section
    data-testid="page-hero"
    className="relative pt-40 pb-20 md:pt-52 md:pb-28 overflow-hidden"
  >
    <div className="absolute inset-0">
      <img src={image} alt="" className="w-full h-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-r from-black via-black/90 to-black/60" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-transparent to-black/70" />
    </div>

    <div className="relative z-10 max-w-7xl mx-auto px-6">
      <motion.div
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7 }}
        className="flex items-center gap-3 text-xs tracking-[0.25em] uppercase text-[#D4AF37] mb-6"
      >
        <span className="h-px w-10 bg-[#D4AF37]/60" />
        {overline}
      </motion.div>
      <motion.h1
        data-testid="page-hero-title"
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.9, delay: 0.1 }}
        className="font-display font-semibold text-4xl md:text-6xl tracking-tight leading-[1.05] max-w-4xl"
      >
        {title}
      </motion.h1>
      {subtitle && (
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.25 }}
          className="font-display italic text-xl md:text-2xl text-white/75 mt-5"
        >
          {subtitle}
        </motion.p>
      )}
    </div>
  </section>
);
